const d = new Date();
const y = d.getFullYear() - 2021;
const m = d.getMonth();
const year = m > 6 ? y + 0.5 : y;

export const intro = `With over ${year} years of experience in software development, I have solid proficiency in JavaScript, React.js, Next.js, TypeScript, HTML, and CSS. I bring valuable experience with Node.js and Python, enabling me to deliver robust and scalable software solutions.`;
export const role =
  'I am committed to building high-quality software dedicating myself to writing clean abd maintainable code, collaborating effectively with cross-functional teams, and integrating APIs to ensure project success. My experience in optimizing performance, ensuring compatibility across various platforms, and delivering seamless user interfaces has significantly improved user experiences.';
export const add_skills =
  'In addition to my technical skills, I bring strong analytical and problem-solving abilities that enable me to effectively troubleshoot issues and optimize performance. I am enthusiastic about contributing my skills and experience to support the team and drive the company’s growth and success.';

export const languages = [
  { lang: 'HTML, CSS', proficiency: 'expert' },
  { lang: 'JavaScript', proficiency: 'expert' },
  { lang: 'React.js', proficiency: 'expert' },
  { lang: 'Typescript', proficiency: 'proficient' },
  { lang: 'Next.js, React Native', proficiency: 'proficient' },
  { lang: 'Node.js (Express), Python (Django)', proficiency: 'proficient' },
  { lang: 'MySQL, PostgreSQL', proficiency: 'competent' },
];

export const topics = [
  'JWT',
  'Redux',
  'Redux Toolkit',
  'Context-API',
  'Soket.IO',
  'MQTT',
  'REST APIs',
  'Unit Testing',
  'Jest',
  'SCSS',
  'CSS-Modules',
  'Material-UI',
  'Tailwind-CSS',
  'NativeWind',
  'Styled-components',
  'Bootstrap',
  'Recharts',
  'Chartjs',
  'Git',
  'Agile Development',
  'Jira',
  'DevTools',
  'Slack',
];
export const os = ['Mac', 'windows'];

export const experiences = [
  {
    id: 1,
    title: 'Software Engineer (React.js)',
    inst: 'Think Limited, Dhaka, Bangladesh',
    from: 'November, 2022',
    to: 'Present',
    responsibilities: [
      {
        id: 1,
        title:
          'Architected and optimized application design that effectively utilized existing resources and met project requirements.',
      },
      {
        id: 2,
        title:
          'Spearheaded a code modularity and reuse initiative resulting in a substantial reduction in development costs and time.',
      },
      {
        id: 3,
        title:
          'Engineered and implemented advanced functionalities within application components and modules strictly adhered to the Single Responsibility Principle.',
      },
      {
        id: 4,
        title:
          'Worked with cross-functional teams to integrate RESTful APIs and MQTT protocols for historical and real-time data visualization.',
      },
      {
        id: 5,
        title:
          'Delivered responsive, accessible designs that ensured cross-device and cross-browser compatibility.',
      },
    ],
    comment:
      'Architected and optimized application design that effectively utilized existing resources and met project requirements.',
  },
  {
    id: 2,
    title: 'Software Engineer (React.js)',
    inst: ' RAENA RU PTE LTD, Singapore (Remote)',
    from: 'April, 2022',
    to: 'October, 2022',

    responsibilities: [
      {
        id: 1,
        title:
          'Partnered with the design team to seamlessly integrate user interfaces into scalable web applications significantly enhanced user satisfaction.',
      },
      {
        id: 2,
        title:
          'Transformed new features and designs into efficient, functional components with clearly defined props and states.',
      },
      {
        id: 3,
        title:
          'Collaborated with the team to integrate REST APIs into existing applications and optimized performance and functionality.',
      },
      {
        id: 4,
        title:
          'Elevated code quality by implementing thorough testing and debugging practices significantly reduced bug incidence.',
      },
    ],
    comment:
      'Partnered with the design team to seamlessly integrate user interfaces into scalable web applications significantly enhanced user satisfaction.',
  },

  {
    id: 3,
    title: 'Frontend Developer',
    inst: 'Generation Net Limited, Dhaka, Bangladesh',
    from: 'January, 2021',
    to: 'may, 2022',
    responsibilities: [
      {
        id: 1,
        title:
          'Converted wireframes and designs into fully functional websites and delivered seamless user experiences.',
      },
      {
        id: 2,
        title:
          'Established robust methods, ensured pixel-perfect design fidelity, and maintained clean, reusable components, resulting in consistently responsive web pages.',
      },
      {
        id: 3,
        title:
          'Actively participated in code reviews, providing constructive feedback that enhanced overall user experience and code quality.',
      },
    ],
    comment:
      'Established robust methods, ensured pixel-perfect design fidelity, and maintained clean, reusable components, resulting in consistently responsive web pages',
  },
];

export const responsibility = [
  {
    id: 1,
    title:
      'Architected and optimized application design that effectively utilized existing resources and met project requirements',
  },
  {
    id: 2,
    title:
      ' Spearheaded a code modularity and reuse initiative resulting in a substantial reduction in development costs and time.',
  },
  {
    id: 3,
    title:
      'Engineered and implemented advanced functionalities within application components and modules strictly adhered to the Single Responsibility Principle',
  },
  {
    id: 4,
    title:
      'Worked with cross-functional teams to integrate RESTful APIs and MQTT protocols for historical and real-time data visualization.',
  },
  {
    id: 5,
    title:
      'Delivered responsive, accessible designs that ensured cross-device and cross-browser compatibility.',
  },
  {
    id: 6,
    title:
      'Established robust methods, ensured pixel-perfect design fidelity, and maintained clean, reusable components, resulting in consistently responsive web pages.',
  },
  {
    id: 7,
    title:
      'Actively participated in code reviews, providing constructive feedback that enhanced overall user experience and code quality.',
  },
];
